import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import axios from 'axios';
import { useEffect, useState } from 'react';
import { formatDate, formatTime } from '../../helper/helper';
import Modal from 'react-modal';
import AuthImage from '../../component/common/AuthImage';

const Rekap = ({ data }) => {
    const [dataAbsensi, setDataAbsensi] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const header = {
        withCredentials: true,
    }

    const getData = async () => {
        await axios.get(`/api/absensi/${data.user.id_user}`, header)
            .then(response => {
                setDataAbsensi(response.data)
            })
    }

    useEffect(() => {
        getData()
    }, [])

    const openModal = (item) => {
        setSelectedItem(item);
        setModalIsOpen(true);
    }

    const closeModal = () => {
        setModalIsOpen(false);
        setSelectedItem(null);
    }

    console.log(dataAbsensi);

    return (
        <>
            <div className="w-full bg-white flex justify-center items-center rounded-md" style={{ filter: "drop-shadow(0px 0px 9px rgba(0,0,0,0.18))" }}>
                <div className="w-full mb-8 relative">
                    <div className="flex flex-col mb-8">
                        <div className="overflow-x-auto sm:mx-0.5 lg:mx-0.5">
                            <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                                <div className="overflow-hidden">
                                    <table className="min-w-full">
                                        <thead className="bg-white border-b">
                                            <tr>
                                                <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-4 text-center">
                                                    No
                                                </th>
                                                <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4 text-left">
                                                    Tanggal
                                                </th>
                                                <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4 text-center">
                                                    Masuk
                                                </th>
                                                <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4 text-center">
                                                    Pulang
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataAbsensi?.map((item, index) => {
                                                return (
                                                    <tr onClick={() => openModal(item)} key={index} className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">
                                                        <td className="px-6 bg-[#fff5f5] py-4 whitespace-nowrap text-sm font-medium text-gray-900">{index + 1}</td>
                                                        <td className="text-sm text-left text-gray-900 font-light px-3 py-4 whitespace-nowrap">
                                                            {formatDate(item.tanggal)}
                                                        </td>
                                                        <td className="text-sm text-gray-900 font-semibold px-3 py-4 whitespace-nowrap">
                                                            {item.waktuMasuk ? formatTime(item.waktuMasuk) : '-'}
                                                        </td>
                                                        <td className="text-sm text-gray-900 font-semibold px-3 py-4 whitespace-nowrap">
                                                            {item.waktuKeluar ? formatTime(item.waktuKeluar) : '-'}
                                                        </td>

                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Detail Modal"
                ariaHideApp={false}
                className="fixed inset-0 flex items-center justify-center p-4 bg-gray-500 bg-opacity-50"
                overlayClassName="fixed z-50 inset-0 bg-gray-800 bg-opacity-75"
            >
                <div className="bg-white overflow-y-scroll rounded-lg shadow-lg max-w-md w-full p-6  max-h-full">
                    <div className='m-4 '>
                        <h2 className="text-2xl text-center font-bold mb-4">Detail Absensi</h2>
                        {selectedItem && (
                            <div className='w-full'>
                                <div>
                                    <p className="mb-2"><strong>Tanggal:</strong> {formatDate(selectedItem.tanggal)}</p>
                                </div>
                                <div className='mx-auto py-2'>
                                    <p className="text-center mx-auto mb-2"><strong>Masuk:</strong> {selectedItem.waktuMasuk ? formatTime(selectedItem.waktuMasuk) : '-'}</p>
                                    <AuthImage className='mx-auto' src={selectedItem.fotoMasuk} alt="" />
                                </div>
                                <div className='mx-auto p-2'>
                                    <p className="text-center mx-auto mb-2"><strong>Pulang:</strong> {selectedItem.waktuKeluar ? formatTime(selectedItem.waktuKeluar) : '-'}</p>
                                    <AuthImage className='mx-auto' src={selectedItem.fotoKeluar} alt="" />
                                </div>
                            </div>
                        )}
                    </div>
                    <button onClick={closeModal} className="w-full py-2 px-4 bg-black text-white rounded-lg">Close</button>
                </div>
            </Modal>
        </>
    )
}

export default Rekap